import React from 'react';
import { DotsWrapperDiv } from './DotsLoader.styles';

const DotsLoader = () => {
  return (
    <DotsWrapperDiv>
      <div className="container">
        <div className="loader">
          <div className="circle">&nbsp;</div>
          <div className="circle">&nbsp;</div>
          <div className="circle">&nbsp;</div>
          <div className="circle">&nbsp;</div>
        </div>
      </div>
    </DotsWrapperDiv>
  );
};

export default DotsLoader;
